module.exports = __webpack_public_path__ + "static/media/CoreCapital_negativo_.ea28a7bb.png";